import { useState } from "react";
import useAuth from "./../../hooks/useAuth";
import { toast } from "react-toastify";

export default function BvnVerification() {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [payload, setPayload] = useState(null);

  return (
    <div>
      <div className="contain">
        <div className="contain-second prod">
          <form
            method="post"
            encType="multipart/form-data"
            onSubmit={async (e) => {
              try {
                e.preventDefault();
                setPayload(null);
                setLoading(true);

                const formData = new FormData(e.target);

                const data = Object.fromEntries(formData);

                data.dob = new Date(data.dob)
                  .toLocaleDateString("en-NG")
                  .replaceAll("/", "-");
                let res = await fetch(
                  `/api/idntity/identities/bvn/${data.bvn}`,
                  {
                    method: "POST",
                    headers: {
                      "x-api-key": user.testKey,
                      Accept: `application/json, text/plain, */*`,
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify(data),
                  }
                );
                
                try {
                  const responseData = await res.json();
                
                  if (responseData.status === "success") {
                    setPayload(responseData.data);
                    return toast.success("Request successful");
                  } else {
                    // Handle server-side errors (e.g., validation errors, request processing errors)
                    const errorMessage = responseData.message;
                    throw new Error(errorMessage);
                  }
                } catch (error) {
                  // Handle JSON parsing errors or other unexpected errors
                  throw new Error(error.message);
                }
              } catch (err) {
                toast.dismiss();
                toast.error(err.message, {
                  position: "top-center",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              } finally {
                setLoading(false);
              }
            }}
          >
            <div className="field">
              <label className="label" htmlFor="firstName">
                First name
              </label>
              <input
                className="input is-normal"
                type="text"
                name="firstname"
                id="firstname"
                placeholder="Enter first name"
                required
              ></input>
            </div>
            <div className="field">
              <label className="label" htmlFor="lastName">
                Last name
              </label>
              <input
                className="input is-normal"
                type="text"
                name="lastname"
                id="lastname"
                placeholder="Enter last name"
                required
              ></input>
            </div>
            <div className="field">
              <label className="label" htmlFor="bvn">
                BVN
              </label>
              <input
                className="input is-normal"
                type="tel"
                name="bvn"
                id="bvn"
                placeholder="Enter BVN"
                required
                maxLength={11}
                minLength={11}
              ></input>
            </div>
            <div className="field">
              <label className="label" htmlFor="phone">
                Phone number
              </label>
              <input
                className="input is-normal"
                type="tel"
                name="phone"
                id="phone"
                placeholder="Enter phone number"
                required
                maxLength={11}
              ></input>
            </div>
            <div className="field">
              <label className="label" htmlFor="dob">
                Date of birth
              </label>
              <input
                className="input is-normal"
                type="date"
                name="dob"
                id="dob"
                placeholder="Enter date of birth"
                required
              ></input>
            </div>
            {/* <div className="field">
              <label className="label">Input option</label>
              <div className="control has-icons-left has-icons-right">
                <div className={`select`} style={{ width: "100%" }}>
                  <select style={{ width: "100%" }} required name="input">
                    <option>Choose an input option</option>
                    <option value="image">Image</option>
                  </select>
                </div>

                <span className="icon is-small is-left">
                  <i className="fa-solid fa-photo-film"></i>
                </span>
              </div>
            </div>
            <div className="field">
              <label className="label">Choose file</label>
              <div className="file has-name is-fullwidth">
                <label className="file-label">
                  <input
                    className="file-input"
                    type="file"
                    accept=".png, .jpeg, .jpg"
                    name="uploaded_image"
                    required
                    onChange={(e) => {
                      if (e.target.files[0]?.name) {
                        try {
                          if (e.target.files[0]?.size > 1048576 * 5)
                            throw new Error("File size cannot exceed 5mb");

                          setFileName(e.target.files[0].name);
                        } catch (err) {
                          toast.dismiss();
                          toast.error(err.message, {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                          });
                        }
                      }
                    }}
                  />
                  <span className="file-cta">
                    <span className="file-label">Choose a file…</span>
                  </span>
                  <span className="file-name">{fileName}</span>
                </label>
              </div>
            </div> */}
            <div className="field">
              <p className="control">
                <button
                  className={`spread-button full mt-5 button ${
                    loading ? "is-loading" : ""
                  }`}
                >
                  Lookup
                </button>
              </p>
            </div>
          </form>
        </div>
        <div className="contain-first prod" style={{ padding: "0px" }}>
          {!loading && payload?.firstname && (
            <div className="results-container  p-5">
              <label className="label mb-2">BVN verification</label>
              <img
                src={`data:image/png;base64, ${payload.photo}`}
                style={{
                  width: "200px",
                  height: "200px",
                  objectFit: "cover",
                  borderRadius: "10px",
                }}
              />
              <div className="results mt-5 pl-1">
                <p className="has-text-grey-light">First name</p>
                <p>{payload.firstname}</p>
              </div>
              <div className="results mt-3 pl-1">
                <p className="has-text-grey-light">Last name</p>
                <p>{payload.lastname}</p>
              </div>
              <div className="results mt-3 pl-1">
                <p className="has-text-grey-light">Middle name</p>
                <p>{payload.middlename}</p>
              </div>
              <div className="results mt-3 pl-1">
                <p className="has-text-grey-light">Gender</p>
                <p className="is-uppercase">{payload.gender}</p>
              </div>
              {/* <div className="results mt-3 pl-1">
                <p className="has-text-grey-light">Nationality</p>
                <p className="is-capitalized">{payload.nationality}</p>
              </div> */}
              <div className="results mt-3 pl-1">
                <p className="has-text-grey-light">Birth Date</p>
                <p>{formatBirthDate(payload.birthdate)}</p>
              </div>
              <div className="results mt-3 pl-1">
                <p className="has-text-grey-light">BVN</p>
                <p>{payload.bvn}</p>
              </div>
              <div className="results mt-3 pl-1">
                <p className="has-text-grey-light">Phone Number</p>
                <p>{payload.phone}</p>
              </div>
            </div>
          )}
        </div>
        <style jsx="true">
          {`
            .results {
              display: flex;
              align-items: center;
            }
            .results > p:first-of-type {
              flex-basis: 150px;
              flex-shrink: 0;
            }

            .prod {
              padding: 1rem 2rem;
              border: 1px solid #eee;
              border-radius: 10px;
            }
            .prod img {
              width: 100%;
              height: 100%;
            }
            .contain {
              margin-left: auto;
              margin-right: auto;
              width: 100%;
              display: grid;
              grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
              grid-auto-rows: minmax(300px, auto);
              grid-gap: 1rem;
              justify-content: space-between;
              margin-bottom: 1.5rem;
            }
          `}
        </style>
      </div>
    </div>
  );
}

function formatBirthDate(birthdate) {
  if (!birthdate) {
    return "No birth date available";
  }

  // Split the date string by "-"
  const dateParts = birthdate.split("-");

  // Ensure that the date string has three components (day, month, and year)
  if (dateParts.length !== 3) {
    return "Invalid date format";
  }

  // Convert the date string to ISO 8601 format (YYYY-MM-DD)
  const isoDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;

  // Create a new Date object with the ISO 8601 date
  const birthDate = new Date(isoDate);

  // Check if the Date object is valid
  if (isNaN(birthDate.getTime())) {
    return "Invalid date value";
  }

  // Format the Date object as a medium date style for "en-NG" locale
  return new Intl.DateTimeFormat("en-NG", {
    dateStyle: "medium",
  }).format(birthDate);
}
